<template>
  <span>
    <!-- Section header -->
    <transition name="drop" appear mode="out-in">
      <edit-person-toggle
        v-if="
          typeOfContactClicked == 'other_event' && getAddOrEditPerson == 'EDIT'
        "
        :hide-drop-down="hideDropDown"
      />
    </transition>
    <section-header
      :selected="selected"
      :selected-client="selectedClient"
      :selected-other="selectedOther"
      :change-selected="changeSelected"
      :change-selected-client="changeSelectedClient"
      :change-selected-other="changeSelectedOther"
      :toggle-sort-order="toggleSortOrder"
      :sort-order="sortOrder"
    />
    <!-- Remaining -->
    <div id="tabBody">
      <div id="mainContentReplace">
        <div id="mainContent">
          <div class="tableContent overflow" id="table_area">
            <div class="table-mobile" id="table-mobile">
              <table>
                <tbody
                  class="d-block"
                  v-if="
                    filteredContacts !== false && filteredContacts.length > 0
                  "
                >
                  <!-- Client Action -->
                  <client-action-vue
                    v-for="other in filteredContacts"
                    :key="other.type + '.' + other.id"
                    :id="other.id"
                    :client-id="other.type + '.' + other.id"
                    :name="other.name"
                    :phones="other.phone"
                    :emails="other.email==null?[]:other.email"
                    :active="true"
                    :userID="other.user_id"
                    :provider-id="other.provider"
                    :by="other.type === 'person' ? 'CLIENTS' : 'OTHERS'"
                    :favourite-id="other.favourite_id"
                    :person-or-other-event="other.type"
                    :selected-phone="other.selected_phone"
                    :inner-users="other.users"
                    :userType="other.type"
                    :typeOfContactClicked="typeOfContactClicked"
                    :showAdd="showAdd"
                    ref="eachAction"
                  />
                </tbody>
                <tbody class="d-block" v-else>
                  <tr class="d-block">
                    <td class="d-block" colspan="2">
                      <a href="#" @click.stop.prevent
                        >No other contacts to show</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- end tableContent -->
        </div>
        <!-- end mainContent -->
      </div>
      <!-- end mainContentReplace -->
      <div class="clear"></div>
    </div>
  </span>
</template>

<script>
import EditPersonToggle from "../Appointment/AddAppointment/AddToggle/EditPersonToggle";
import SectionHeader from "./Header";
import ClientActionVue from "../common/ClientAction";
import { mapGetters } from "vuex";
import { addNewChatAndCallMixin } from "../../mixins/addNewChatAndCallMixin";

export default {
  name: "ContactSection",
  mixins: [addNewChatAndCallMixin],
  props: {
    sortOrder: Boolean,
    toggleSortOrder: Function,
    showAdd: Boolean,
    hideAdd: Function
  },
  data() {
    return {
      selected: "all", // Currently which is selected
      selectedClient: "not-archived", // Select archived clients
      selectedOther: "all", // What in others is selected
      typeOfContactClicked: false // What in others is selected
    };
  },
  methods: {
    hideDropDown() {
      this.hideAdd();
      this.typeOfContactClicked = false;
    },
    /**
     * Escape the given chars
     */
    escape(s) {
      // eslint-disable-next-line no-useless-escape
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    },
    /**
     * Change the selected with the given value
     */
    changeSelected(value) {
      this.selected = value;
    },
    /**
     * Change client selected
     */
    changeSelectedClient(value) {
      this.selectedClient = value;
    },
    /**
     * Change other selected
     */
    changeSelectedOther(value) {
      this.selectedOther = value;
    },
    /**
     * Common filter function
     */
    commonFilter(val) {
      if (this.favouriteMode) {
        return (
          val.name
            .toLowerCase()
            .search(this.escape(this.searchBy.toLowerCase())) !== -1 &&
          val.favourite_id !== 0
        );
      }
      return (
        val.name
          .toLowerCase()
          .search(this.escape(this.searchBy.toLowerCase())) !== -1
      );
    }
  },
  computed: {
    ...mapGetters({
      searchBy: "getSearchValue" // Search value in the search bar
    }),
    ...mapGetters("person", {
      getAddOrEditPerson: "getAddOrEditPerson" // Search value in the search bar
    }),

    /**
     * Filtered contact
     */
    filteredContacts() {
      // Step 1: When all is selected
      if (this.selected === "all" && this.allPhone) {
        return this.allPhone.filter(this.commonFilter);
      }

      // Step 2: Check if we need to return client
      if (this.selected === "client" && this.clients) {
        return this.filteredClientsForContacts;
      }

      // Step 3: When others is selected
      if (this.selected === "other") {
        return this.filteredOthers;
      }

      // Step 4: Default return
      return false;
    },
    /**
     * Filtered clients for contacts
     */
    filteredClientsForContacts() {
      if (this.selectedClient === "not-archived") {
        return this.clients
          .filter(client => {
            return +client.status === 1 || !client.status;
          })
          .filter(this.commonFilter)
          .sort(this.sortNames);
      }
      return this.clients
        .filter(client => {
          return +client.status === 2;
        })
        .filter(this.commonFilter)
        .sort(this.sortNames);
    },
    /**
     * Filter others
     */
    filteredOthers() {
      // Step 1: When all is slected
      if (this.selectedOther === "all" && this.othersAll) {
        return this.othersAll.filter(this.commonFilter).sort(this.sortNames);
      }

      // Step 2: When person is selected
      if (this.selectedOther === "person" && this.people) {
        return this.people.filter(this.commonFilter).sort(this.sortNames);
      }

      // Step 3: When group is selected
      if (this.selectedOther === "group" && this.groups) {
        return this.groups.filter(this.commonFilter).sort(this.sortNames);
      }

      // Step 4: When user is selected
      if (this.selectedOther === "user") {
        let allUsers = [];
        if (this.subscribers) {
          allUsers = [...allUsers, ...this.subscribers];
        }
        if (this.appUsers) {
          allUsers = [...allUsers, ...this.appUsers];
        }
        return allUsers.filter(this.commonFilter).sort(this.sortNames);
      }

      // Step 5: Default return
      return false;
    }
  },
  components: {
    ClientActionVue,
    SectionHeader,
    EditPersonToggle
  }
};
</script>

<style scoped>
#tabBody {
  padding-top: 0;
  background-color: #fff;
  margin: 1px 1em;
  clear: both;
  position: relative;
  height: auto;
  min-height: 340px;
  overflow: hidden;
  margin-bottom: 20px;
}

#mainContentReplace {
  padding-right: 0px;
  padding: 1em 0em 0 0;
  height: auto;
}

#mainContent {
  overflow: hidden;
  min-height: 340px;
  padding: 11px 0em 0;
  width: auto;
}

html
  body
  div#mainContainer
  div#tabBody
  div#mainContentReplace
  div#mainContent
  div.tableContent {
  margin-bottom: 30px;
  position: relative;
}

.overflow {
  overflow: auto;
}

.tableContent {
  margin: 0 0 0.8em 0;
  min-height: 10px;
  width: auto;
}

html
  body
  div#mainContainer
  div#tabBody
  div#mainContentReplace
  div#mainContent
  div#table_area.tableContent
  table {
  position: relative;
}

#table-mobile.table-mobile table {
  width: 100%;
  display: block;
}
#table-mobile.table-mobile table tr {
  display: block;
}

.tableContent table {
  padding-top: 18px;
}

@media (max-width: 768px) {
  #mainContentReplace {
    padding-right: 0px;
  }

  #table-mobile.table-mobile,
  .search {
    width: 100%;
  }
}

@media (max-width: 481px) {
  #mainContentReplace {
    padding: 0px;
  }
}
@media (max-width: 414px) {
}
</style>
